import React from 'react';

interface ITransactionStats {
  value: number | string;
  heading: string;
}

const TransactionStats = ({ value, heading }: ITransactionStats) => {
  return (
    <div className="stats-container">
      <h2>{heading}</h2>
      <p>{value} ETH</p>
    </div>
  );
};

export default TransactionStats;
